@switch (mode) {
  @case ('panel') {
    <crm-panel-driven-form
      [objectType]="objectType"
      [objectSubtype]="objectSubtype"
      [existingObjectId]="existingObjectId"
      [submitButtonText]="submitButtonText | translate"
      [cancelButtonText]="cancelButtonText | translate"
      [loadingStatus]="loadingStatus"
      [savingStatus]="savingStatus"
      [fieldConfig]="fieldConfig"
      [readOnly]="readOnly"
      [inlineEdit]="true"
      [isEditing]="isEditing"
      [serverValidationErrors]="serverValidationErrors"
      (formSubmit)="onSubmit($event)"
      (formCancel)="onCancel()"
    ></crm-panel-driven-form>
  }
  @default {
    <crm-card-group-driven-form
      [objectType]="objectType"
      [existingObjectId]="existingObjectId"
      [submitButtonText]="submitButtonText | translate"
      [cancelButtonText]="cancelButtonText | translate"
      [loadingStatus]="loadingStatus"
      [savingStatus]="savingStatus"
      [fieldConfig]="fieldConfig"
      [readOnly]="readOnly"
      [isEditing]="isEditing"
      [serverValidationErrors]="serverValidationErrors"
      (formSubmit)="onSubmit($event)"
      (formCancel)="onCancel()"
      [(associationFormFields)]="associationFormFields"
    ></crm-card-group-driven-form>
  }
  @case ('basic-field-group') {
    <crm-basic-field-group-form
      [objectType]="objectType"
      [existingObjectId]="existingObjectId"
      [submitButtonText]="submitButtonText | translate"
      [cancelButtonText]="cancelButtonText | translate"
      [loadingStatus]="loadingStatus"
      [savingStatus]="savingStatus"
      [fieldConfig]="fieldConfig"
      [isEditing]="isEditing"
      [serverValidationErrors]="serverValidationErrors"
      [readOnly]="readOnly"
      (formSubmit)="onSubmit($event)"
      (formCancel)="onCancel()"
    ></crm-basic-field-group-form>
  }
}
